"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var json_api_fetch_1 = require("./json_api_fetch");
/**
 * Fetch a User object by its ID in json api format
 * Currently only for user contributor data on a wall
 * @param id User Id
 * @param options ApiFetchOptions.
 * @returns A Promise that resolves to a [[JsonAPIResponse<User>]].
 *
 */


function fetchUser(id) {
  return json_api_fetch_1.jsonApiFetch("users/" + id);
}

exports.default = fetchUser;